class TC_Parallax {
    constructor () {
        if ($('.video-cover').length || $('.js-parallax').length || $('.js-parallax-overlay').length) {
            this.initEvents();
        }
    }

    initEvents () {
        this.hasVideoCoverParallax = $('.video-cover').length;
        this.hasParallax = $('.js-parallax').length;
        this.hasParallaxOverlay = $('.js-parallax-overlay').length;
        this.videoCover = $('.video-cover');
        this.parallaxBlocks = $('.js-parallax');
        this.parallaxOverlayBlocks = $('.js-parallax-overlay');
        this.win = $(window);

        this.win.on('scroll', this.scroll.bind(this));
        this.win.trigger('scroll');
    }

    scroll (e) {
        let currentScroll = this.win.scrollTop();
        let windowHeight = window.outerHeight;

        if (this.hasVideoCoverParallax) {
            let videoCover = $('.video-cover');
            let videoCoverHeight = videoCover.outerHeight();

            if (currentScroll < videoCoverHeight) {
                videoCover.css('transform', 'translateY(' + currentScroll + 'px)');
            }
        }

        if (this.hasParallax) {
            let toAnimate = [];

            for (let i = 0; i < this.parallaxBlocks.length; i++) {
                let elementTop = this.parallaxBlocks.eq(i).offset().top;
                let elementHeight = this.parallaxBlocks.eq(i).outerHeight();

                if (currentScroll + windowHeight > elementTop && currentScroll + windowHeight < elementTop + elementHeight + windowHeight) {
                    toAnimate.push({
                        el: this.parallaxBlocks.eq(i).find('.js-parallax-block').eq(0),
                        top: elementTop,
                        height: elementHeight
                    });
                }
            }

            for (let i = 0; i < toAnimate.length; i++) {
                let offset = (currentScroll - toAnimate[i].top) / (toAnimate[i].height + windowHeight) * 400;
                toAnimate[i].el.css('transform', 'translateY(' + offset + 'px)');
            }
        }

        if (this.hasParallaxOverlay) {
            for (let i = 0; i < this.parallaxOverlayBlocks.length; i++) {
                let block = this.parallaxOverlayBlocks.eq(i).find('.js-parallax-overlay-block').eq(0);
                let blockHeight = block.outerHeight();

                if (currentScroll < blockHeight) {
                    block.css('transform', 'translateY(' + currentScroll + 'px)');
                    block.css('opacity', (1 - (currentScroll / blockHeight)));
                }   
            }
        }
    }
}